<div class="mat-page-container">
    <app-search [searchOptions]="searchOptions" (searchEvent)="searchDetails($event)"></app-search>
    <app-table [tableSettings]="tableData" (selectChecks)="getCustomerIds($event)"></app-table>
</div>
